import useTheme from "../../../../common/hooks/useTheme";
import Logo from "../../../../common/svgs/logo";
import useScreenInfo from "../../../../providers/useScreenInfo";

const QuestionnaireScreenWrapperMobile = () => {
  const theme = useTheme();
  const { orientation } = useScreenInfo();

  return (
    <div
      style={{
        height: "90vh",
        width: "100vw",
        padding: "16px 64px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "32px",
          paddingBottom: "16px",
        }}
      >
        <Logo width={300} height={100} />
      </div>
      <div style={styles.text(theme)}>
        This page is not available in landscape version
      </div>
      <div style={styles.text(theme)}>Please rotate your device</div>
    </div>
  );
};

export default QuestionnaireScreenWrapperMobile;

const styles = {
  text: (theme: any) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "20px",
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
    textAlign: "center" as "center",
    paddingBottom: "30px",
  }),
  title: (theme: any) => ({
    paddingTop: "30px",
    fontFamily: "var(--font-Medium)",
    fontSize: "20px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    lineHeight: "26px",
    flex: 1,
  }),
};
